import { Controller } from "@hotwired/stimulus"

// Reusable auto-submit controller for forms
// Submits the form when inputs change, with optional debouncing
//
// Usage:
//   <form data-controller="autosubmit" data-autosubmit-debounce-value="300">
//     <input data-action="input->autosubmit#submit">
//     <select data-action="change->autosubmit#submit">
//   </form>
//
// Values:
//   debounce: milliseconds to wait before submitting (default: 0)
export default class extends Controller {
  static values = {
    debounce: { type: Number, default: 0 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    this.clearTimeout()
  }

  submit() {
    this.clearTimeout()

    if (this.debounceValue > 0) {
      // Debounce the submission
      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, this.debounceValue)
    } else {
      // Submit immediately
      this.element.requestSubmit()
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
